// eslint-disable-next-line import/prefer-default-export
export enum Truncate {
    Hourly = 'hourly',
    Daily = 'daily',
    Weekly = 'weekly',
    Monthly = 'monthly',
}
